import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { Role } from 'app/core/user/user.enum';
import { catchError, map, of, switchMap, take } from 'rxjs';

export const superAdminGuard: CanActivateFn = () => {
    const userService = inject(UserService);
    const router = inject(Router);

    // We fetch the current system user explicitly to avoid race conditions with resolvers,
    // ensuring we don't stall if currentSystemUser$ hasn't emitted yet.
    return userService.getCurrentSystemUser().pipe(
        switchMap(() => userService.currentSystemUser$.pipe(take(1))),
        map(user => {
            if (user && (user.role === Role.SUPER_ADMIN || user.role === Role.DEVELOPER)) {
                return true;
            }
            return router.createUrlTree(['/access-denied']);
        }),
        catchError(() => of(router.createUrlTree(['/access-denied'])))
    );
};
